import { useEffect, useState } from "react";
import AppShell from "@/components/AppShell";
import KycWizard from "@/components/kyc/KycWizard";
import DigioKycFlow from "@/components/kyc/DigioKycFlow";
import { api } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function KycPage() {
  const [mode, setMode] = useState(null);

  useEffect(() => {
    api.get("/api/kyc/mode").then(({ data }) => setMode(data)).catch(() => setMode({ kyc_mode: "manual" }));
  }, []);

  return (
    <AppShell>
      <div className="space-y-6">
        <div>
          <h1 className="text-[26px] font-bold text-cm-navy tracking-tight">KYC Verification</h1>
          <p className="text-[13px] text-cm-grey mt-1">
            Complete your KYC to unlock trading, deposits and withdrawals.
          </p>
        </div>
        {!mode ? (
          <div className="text-cm-grey text-[13px] inline-flex items-center gap-2">
            <Loader2 size={14} className="animate-spin" /> Loading…
          </div>
        ) : mode.kyc_mode === "auto" ? (
          <DigioKycFlow />
        ) : mode.kyc_mode === "disabled" ? (
          <div className="rounded-[16px] border border-[var(--cm-border)] bg-white p-6 text-[14px] text-cm-grey">
            KYC verification is currently disabled. Contact support.
          </div>
        ) : (
          <KycWizard faceMatchRequired={mode.face_match_required} />
        )}
      </div>
    </AppShell>
  );
}
